import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, TrendingUp, Mail, DollarSign } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function ChristmasPalace2() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-274" data-mp="2u6w9b91viqxf">
      <div className="max-w-6xl mx-auto px-4" data-id="element-275" data-mp="2u98zg9hsc7lk">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-276" data-mp="2y7ydm4andt69">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-277" data-mp="386nqtjrlmpg6" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-278" data-mp="3d4pekhzyzcxz">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-279" data-mp="3d3ny1y06py8v">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-280" data-mp="1du7pmxdnu1i6">
              The Engage Machine
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-281" data-mp="289nyz43qbue7">
              Paid Media
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-282" data-mp="1yjbhxlv4ijct">
              Website CRO
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-283" data-mp="2r7h329q3aad6">
              Social Media
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-284" data-mp="2h8rj8bemufua">
              Email Marketing
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-285" data-mp="15tme70r1457i">
            The Christmas Palace
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-286" data-mp="11qzgwkbl9s2x">
            How we grew a milllion dollar business online store 56% in one
            season
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-287" data-mp="tbs291fstaqu">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-288" data-mp="tah0f75wyd2d">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-289" data-mp="y9tw8heriuh3">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-290" data-mp="kh3yjfpvg145">
                <TrendingUp className="w-24 h-24 text-engage-yellow" data-id="element-291" data-mp="akslgnigj78n" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-292" data-mp="aixxt1fsx10v">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-293" data-mp="fhrbouz02u1k">
                  <TrendingUp className="w-6 h-6 text-engage-yellow" data-id="element-294" data-mp="5lfv3ssdni1b" />
                </div>
                <div data-id="element-295" data-mp="3j2i1yyruxhcc">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-296" data-mp="3j1zzvliik8wi">
                    +56%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-297" data-mp="3e61em6shf70b">
                    Revenue Growth
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-298" data-mp="5w9jkr2zbe1b">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-299" data-mp="wwrnrx93grv">
                <Mail className="w-24 h-24 text-engage-yellow" data-id="element-300" data-mp="eqe8h4yjyfe7" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-301" data-mp="anrlpigqnknv">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-302" data-mp="on951ib9m5pu">
                  <Mail className="w-6 h-6 text-engage-yellow" data-id="element-303" data-mp="jltmbwwk8bam" />
                </div>
                <div data-id="element-304" data-mp="13nodycl0pt0e">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-305" data-mp="17r49f5lcpnbi">
                    +102%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-306" data-mp="1cimadtndjnwh">
                    Email Revenue Growth
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-307" data-mp="kszkam2pv50j">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-308" data-mp="tqtdvp93jkk0">
                <DollarSign className="w-24 h-24 text-engage-yellow" data-id="element-309" data-mp="yrzavz9shtzc" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-310" data-mp="2568csykv8mhr">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-311" data-mp="2a4rxkvnq3s8j">
                  <DollarSign className="w-6 h-6 text-engage-yellow" data-id="element-312" data-mp="3upyf2doza8z7" />
                </div>
                <div data-id="element-313" data-mp="3ppkgdm99obdu">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-314" data-mp="3ky2ix86gcsxm">
                    5.08x
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-315" data-mp="3fyg5axmppaoa">
                    ROAS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-316" data-mp="31yon0kp5x84h">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-317" data-mp="32118v8y1k2mt">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-318" data-mp="2x2hove30d0x3">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-319" data-mp="v88od7co0gfr" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-320" data-mp="2poyxgzlgb9pd">
              A premium brand with strong demand{'\u2014'}but a fragile growth
              model. The Christmas Palace relied heavily on discounts and
              peak-season spikes to drive revenue, leaving little control over
              performance the rest of the year. Limited creative output and
              underdeveloped channels like SMS and B2B restricted scalability,
              turning growth into a reactive process instead of a predictable
              system.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-321" data-mp="2zdqn3131hhx4">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-322" data-mp="33g3ppgmhozpo">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-323" data-mp="1nyk1tlv7vpbm" />
              <div className="relative z-10" data-id="element-324" data-mp="1ryvkit40rfkg">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-325" data-mp="1kgw9lq6a2r2k">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-326" data-mp="1ficm3lc1d783" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-327" data-mp="1uek54ibpk2ls">
                  We engineered a performance-driven ecosystem designed for
                  scale. By massively increasing creative production,
                  restructuring paid media, and activating email, SMS, and B2B
                  as core revenue drivers, we created a system that could
                  continuously generate, capture, and convert demand. Every
                  layer{'\u2014'}from traffic to conversion{'\u2014'}was
                  optimized to work together, not in isolation.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-328" data-mp="e1vcvi9fi4ux">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-329" data-mp="3oohman925qkj" />
              <div className="relative z-10" data-id="element-330" data-mp="3tovq1t3mmecr">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-331" data-mp="2g8axuvzbndn">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-332" data-mp="6jehz4qx1il6" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-333" data-mp="bgdajiuxlhh9">
                  The business evolved from seasonal spikes into a scalable year
                  round revenue engine, achieving a 5.08 ROAS, +56% net sales
                  growth, +102% email revenue growth, and +1,919% SMS growth.
                  Revenue became more predictable, margins improved, and
                  reliance on discounts dropped, turning a reactive model into a
                  controlled and repeatable system for consistent growth.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-334" data-mp="2eporhw5t8x0x">
            <div className="flex justify-center mb-8" data-id="element-335" data-mp="2aowd6oi301xs">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-336" data-mp="25p0coz8lesmz">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-337" data-mp="2yeha6bb2kzq2" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-338" data-mp="uov4w9edzqrm">
              We didn't just scale revenue{'\u2014'}we built a system that
              generates it, with less reliance on discounts and more control
              over growth.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-339" data-mp="1dm4ru0ix7mdm">
              <img src="https://cdn.magicpatterns.com/uploads/8gwvPSjtFihytPMh9DLH8q/The_Christmas_Palace-CS.png" alt="The Christmas Palace" className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 object-cover" data-id="element-340" data-mp="18nl2dq54bsgi" />
              <div className="font-bold text-engage-white text-lg" data-id="element-341" data-mp="1wd5o2gsnp3th">
                The Christmas Palace Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-342" data-mp="1reudu4yg8raq">
                CEO, The Christmas Palace
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-343" data-mp="2fyflgbeotol5">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-344" data-mp="260rorfxiu70c" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-345" data-mp="1s8v41wy6mzdz">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-346" data-mp="1s7jwrn5j39i4">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-347" data-mp="1ibys1h92rv4o">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-348" data-mp="19a8zu97dcs5u">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}